var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDecorationColorSplash = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1265,
    height: 1229,
    viewBox: "0 0 1265 1229",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_106_142)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 462.5,
    cy: 453.738,
    rx: 237.5,
    ry: 228.5,
    fill: "#A908E2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter1_f_106_142)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 743.91,
    cy: 671.031,
    rx: 294.032,
    ry: 334.314,
    transform: "rotate(-12.1718 743.91 671.031)",
    fill: "#0881E2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_106_142",
    x: 0,
    y: 0.238281,
    width: 925,
    height: 907,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 112.5,
    result: "effect1_foregroundBlur_106_142"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_106_142",
    x: 222.902,
    y: 113.344,
    width: 1042.02,
    height: 1115.37,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 112.5,
    result: "effect1_foregroundBlur_106_142"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDecorationColorSplash);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/decoration-color-splash.c2026a25624d1cd963a004b9ea5ef6b2.svg";